import _ from 'underscore';
import React from 'react';
import { Alert } from '@bingads-webui-react/alert';
import { mapAlertLevel } from './util';
import { FloatingBannerProps, FloatingBannerState } from './types';

const methodPrefix = 'floatingBanner';
const logType = {
  message: 'message',
  action: 'action',
  dismiss: 'dismiss',
};

export class FloatingBanner extends React.Component<FloatingBannerProps, FloatingBannerState> {
  static defaultProps: Partial<FloatingBannerProps>;

  constructor(props: FloatingBannerProps) {
    super(props);
    const nextMessage = this.props.alert && this.props.alert.message;
    this.state = { showBanner: _.isString(nextMessage) || React.isValidElement(nextMessage) };
  }

  componentDidMount() {
    this.afterUpdate();
  }

  componentDidUpdate() {
    this.afterUpdate();
  }

  componentWillUnmount() {
    if (this.timerId) {
      clearTimeout(this.timerId);
    }
  }

  private timerId?: number;

  logTrace = (type: string, appendantInfo: string[] = []): void => {
    const methodName = `${methodPrefix}:${type}`;
    const message = _.reduce(
      appendantInfo,
      (memo: string, info: string) => `${memo}:${info}`,
      `${this.props.alert.level}:${(_.isString(this.props.alert.message) ? this.props.alert.message : 'ReactElement')}`
    );

    this.props.logInstrumentation.trace(methodName, message);
  };

  afterUpdate = (): void => {
    if (this.state.showBanner) {
      this.logTrace(logType.message);
      if (this.timerId) {
        clearTimeout(this.timerId);
      }

      if (this.props.autoDismissTime > 0) {
        this.timerId = setTimeout(() => {
          this.dismiss(false);
        }, this.props.autoDismissTime) as any;
      }
    }
  };

  dismiss = (willLog = true): void => {
    if (willLog) {
      this.logTrace(logType.dismiss);
    }

    this.setState({ showBanner: false });
  };

  private actionClicked = (innerText: string): void => {
    this.logTrace(logType.action, [innerText]);
  };

  render() {
    return (
      <div>
        { this.state.showBanner && (
          <div className="floating-banner">
            <Alert
              {...mapAlertLevel(this.props.alert)}
              onDismiss={this.dismiss as any}
              onActionClicked={this.actionClicked}
            />
          </div>
        ) }
      </div>
    );
  }
}

FloatingBanner.defaultProps = {
  alert: {
    message: undefined,
    level: 'Confirmation',
  },
  autoDismissTime: 0,
  logInstrumentation: {
    trace: _.noop,
  },
};
